/* eslint-disable no-unused-vars */
// /* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useTheme } from "@mui/material/styles";
import { Box, List, ListItemButton, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router";
import logStore from "../stores/LogStore";

import {
  FiHome,
  FiBell,
  FiList,
  FiSettings,
  FiLogOut,
  FiUser,
  FiHelpCircle,
  FiUsers,
} from "react-icons/fi";
import { RiAdminFill } from "react-icons/ri";
import { toast } from "react-toastify";
import { observer } from "mobx-react-lite";
import useUserData from "./custom-hooks/useUserData";
import authStore from "../stores/AuthStore";
import {
  readRawPersistedSessionStorageData,
  readCustomFormatPersistedSessionStorageData,
} from "../utils/sessionStorage";
import { toJS } from "mobx";
import { Badge } from "@mui/material";
import { MdWarning } from "react-icons/md";
import warningStore from "../stores/WarningStore";
import alertNotificationStore from "../stores/AlertNotificationStore";

const Sidebar = observer(() => {
  const navigate = useNavigate();
  const theme = useTheme();
  const location = useLocation();

  // Function to get user roles from sessionStorage
  const checkAdminStatus = () => {
    const storedSessionData = sessionStorage.getItem("userFinalSessionData");
    if (storedSessionData) {
      try {
        const parsedData = JSON.parse(storedSessionData);
        const roles = (parsedData?.user?.roles || []).includes("Admin");
        return roles;
      } catch (error) {
        console.error("Error parsing user data from sessionStorage:", error);
      }
    }
  };

  const [isAdmin, setIsAdmin] = useState(false);

  // useEffect(() => {
  //   authStore.loadAuthStore();
  //   console.log("load auth store: ", authStore.user);
  // }, []);

  useEffect(() => {
    const raw = sessionStorage.getItem("userFinalSessionData");
    if (raw) {
      try {
        const parsed = JSON.parse(raw);
        if (parsed?.user) {
          authStore.setUser(parsed.user);
        }
        if (parsed?.userPreference) {
          authStore.setPreference(parsed.userPreference);
        }
      } catch (err) {
        console.error("Failed to restore user from sessionStorage:", err);
      }
    }
  }, []);

  useEffect(() => {
    logStore.connect();
    return () => logStore.disconnect();
  }, []);

  // const currentUser = authStore.getUser();
  const currentUser = authStore.user;
  console.log("Current user is: ", toJS(currentUser));

  const userID = currentUser.id || currentUser.userID;
  const { userData, sessionData } = useUserData(userID);

  // Watch for user changes from MobX store and update admin status
  useEffect(() => {
    setIsAdmin(checkAdminStatus());
  }, [currentUser]);

  useEffect(() => {
    if (userData) {
      console.log("User data from hook: ", userData);
    }
    if (sessionData) {
      console.log("Session data from hook: ", sessionData);
    }
  }, [userData, sessionData]);

  useEffect(() => {
    const retrieveUserSessionData = () => {
      if (userData) {
        const updatedUser = { ...userData };
        authStore.setUser(updatedUser);
        console.log(
          "Updated MobX store with fresh React Query data: ",
          authStore.getUser()
        );
      }

      if (sessionData && sessionData.userPreference) {
        const updatedUserPreference = { ...sessionData.userPreference };
        console.log(
          "Updated user preference data in sidebar: ",
          updatedUserPreference
        );
        authStore.setPreference(updatedUserPreference);
        console.log(
          "Updated MobX store with user preference data: ",
          authStore.getPreference()
        );
      }
    };
    retrieveUserSessionData();
  }, [userData, sessionData]);

  useEffect(() => {
    console.log(
      "Read raw session storage: ",
      readRawPersistedSessionStorageData
    );
    console.log(
      "Custom persisted data: ",
      readCustomFormatPersistedSessionStorageData()
    );
  }, []);

  const handleLogOut = async () => {
    try {
      await authStore.logout();
      const themeValue = sessionStorage.getItem("theme");
      sessionStorage.clear();
      if (themeValue) {
        sessionStorage.setItem("theme", themeValue);
      }

      toast.success("You have been logged out!");
      sessionStorage.clear();
      navigate("/login");
    } catch (error) {
      toast.error("Cannot logout!");
      console.error("Logout error:", error);
    }
  };

  const unreadAlertCount = alertNotificationStore.alerts.filter(
    (a) => !alertNotificationStore.isAlertReadByUser(a._id)
  ).length;

  // I want to get the role from localStrorage in here and a boolean for checking if user is admin or not

  return (
    <Box
      className="w-64 flex flex-col h-full"
      sx={{
        borderRight: "1px solid",
        borderColor: "divider",
        bgcolor: "background.default",
      }}
    >
      {/* Left Sidebar */}
      <Box className="flex-grow mt-3">
        <List>
          {/* Dashboard */}
          <ListItemButton
            onClick={() => navigate("/dashboard")}
            className="flex items-center gap-2 w-full"
            selected={location.pathname === "/dashboard"}
            sx={{
              bgcolor:
                location.pathname === "/dashboard"
                  ? "action.selected"
                  : "inherit",
              borderLeft:
                location.pathname === "/dashboard"
                  ? "4px solid #1976d2"
                  : "4px solid transparent",
              pl: location.pathname === "/dashboard" ? 1.5 : 2,
            }}
          >
            <FiHome className="text-xl" />
            <Typography className="!font-bold !ml-2">Dashboard</Typography>
          </ListItemButton>

          {/* If user is admin show this admin Item Button */}
          {isAdmin && (
            <ListItemButton
              onClick={() => navigate("/admin/dashboard")}
              className="flex items-center gap-2 w-full"
              selected={location.pathname === "/admin/dashboard"}
              sx={{
                bgcolor:
                  location.pathname === "/admin/dashboard"
                    ? "action.selected"
                    : "inherit",
                borderLeft:
                  location.pathname === "/admin/dashboard"
                    ? "4px solid #1976d2"
                    : "4px solid transparent",
                pl: location.pathname === "/admin/dashboard" ? 1.5 : 2,
              }}
            >
              <RiAdminFill className="text-xl" />
              <Typography className="!font-bold !ml-2">Admin</Typography>
            </ListItemButton>
          )}

          {/* Devices */}
          <ListItemButton
            onClick={() => navigate("/devices")}
            className="flex items-center gap-2"
            selected={location.pathname.startsWith("/devices")}
            sx={{
              bgcolor: location.pathname.startsWith("/devices")
                ? "action.selected"
                : "inherit",
              borderLeft: location.pathname.startsWith("/devices")
                ? "4px solid #1976d2"
                : "4px solid transparent",
              pl: location.pathname.startsWith("/devices") ? 1.5 : 2,
            }}
          >
            <FiList className="text-xl" />
            <Typography className="!font-bold !ml-2">Devices</Typography>
          </ListItemButton>

          {/* Customers */}
          <ListItemButton
            onClick={() => navigate("/customers")}
            className="flex items-center gap-2"
            selected={location.pathname === "/customers"}
            sx={{
              bgcolor:
                location.pathname === "/customers"
                  ? "action.selected"
                  : "inherit",
              borderLeft:
                location.pathname === "/customers"
                  ? "4px solid #1976d2"
                  : "4px solid transparent",
              pl: location.pathname === "/customers" ? 1.5 : 2,
            }}
          >
            <FiUsers className="text-xl" />
            <Typography className="!font-bold !ml-2">Customers</Typography>
          </ListItemButton>

          {/* Alerts */}
          <ListItemButton
            onClick={() => navigate("/alerts")}
            className="flex items-center gap-2"
            selected={location.pathname === "/alerts"}
            sx={{
              bgcolor:
                location.pathname === "/alerts" ? "action.selected" : "inherit",
              borderLeft:
                location.pathname === "/alerts"
                  ? "4px solid #1976d2"
                  : "4px solid transparent",
              pl: location.pathname === "/alerts" ? 1.5 : 2,
            }}
          >
            <Badge
              color="error"
              variant={unreadAlertCount > 0 ? "dot" : "standard"}
              overlap="rectangular"
              invisible={unreadAlertCount === 0}
            >
              <FiBell className="text-xl" />
            </Badge>
            <Typography className="!font-bold !ml-2">Alerts</Typography>
          </ListItemButton>

          {/* Warnings */}
          <ListItemButton
            onClick={() => navigate("/warnings")}
            className="flex items-center gap-2 w-full"
            selected={location.pathname === "/warnings"}
            sx={{
              bgcolor:
                location.pathname === "/warnings"
                  ? "action.selected"
                  : "inherit",
              borderLeft:
                location.pathname === "/warnings"
                  ? "4px solid #1976d2"
                  : "4px solid transparent",
              pl: location.pathname === "/warnings" ? 1.5 : 2,
            }}
          >
            <Badge
              badgeContent={warningStore.unreadWarningIds.length}
              color="error"
              max={99}
              overlap="rectangular"
              sx={{
                "& .MuiBadge-badge": {
                  fontSize: "0.75rem",
                  fontWeight: "bold",
                  padding: "0 6px",
                  height: 20,
                  minWidth: 20,
                  borderRadius: "50%",
                },
              }}
            >
              <MdWarning className="text-xl" />
            </Badge>
            <Typography className="!font-bold !ml-2">Warnings</Typography>
          </ListItemButton>
        </List>
      </Box>

      {/* Bottom Settings & Profile */}
      <Box>
        <List>
          {/* Settings */}
          <ListItemButton
            onClick={() => navigate("/settings")}
            className="flex items-center gap-2"
            selected={location.pathname === "/settings"}
            sx={{
              bgcolor:
                location.pathname === "/settings"
                  ? "action.selected"
                  : "inherit",
              borderLeft:
                location.pathname === "/settings"
                  ? "4px solid #1976d2"
                  : "4px solid transparent",
              pl: location.pathname === "/settings" ? 1.5 : 2,
            }}
          >
            <FiSettings className="text-xl" />
            <Typography className="!font-bold !ml-2">Settings</Typography>
          </ListItemButton>

          {/* Support */}
          <ListItemButton
            onClick={() => navigate("/support")}
            className="flex items-center gap-2"
            selected={location.pathname === "/support"}
            sx={{
              bgcolor:
                location.pathname === "/support"
                  ? "action.selected"
                  : "inherit",
              borderLeft:
                location.pathname === "/support"
                  ? "4px solid #1976d2"
                  : "4px solid transparent",
              pl: location.pathname === "/support" ? 1.5 : 2,
            }}
          >
            <FiHelpCircle className="text-xl" />
            <Typography className="!font-bold !ml-2">Support</Typography>
          </ListItemButton>

          {/* Legal */}
          {/* <ListItemButton className="flex items-center gap-2">
            <FaBalanceScale className="text-xl" />
            <Typography className="!font-bold !ml-2">Legal</Typography>
          </ListItemButton> */}

          {/* Logout */}
          <ListItemButton
            onClick={handleLogOut}
            className="flex items-center gap-2"
            sx={{
              bgcolor:
                location.pathname === "/logout" ? "action.selected" : "inherit",
              borderLeft:
                location.pathname === "/logout"
                  ? "4px solid #1976d2"
                  : "4px solid transparent",
              pl: location.pathname === "/logout" ? 1.5 : 2,
            }}
          >
            <FiLogOut className="text-xl" />
            <Typography className="!font-bold !ml-2">Logout</Typography>
          </ListItemButton>
        </List>

        {/* Profile Section */}
        <button
          className="mt-2 flex items-center space-x-3 p-4 rounded-lg cursor-pointer transition mx-auto border w-[240px] h-[80px]"
          style={{
            bgcolor: theme.palette.background.paper,
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            borderColor: theme.palette.divider,
            transition: "ease-out 0.05s",
          }}
          onClick={() => {
            navigate("/settings", { state: { sessionData: sessionData } });
          }}
        >
          <Box
            className="w-10 h-10 !bg-green-500 rounded-full flex justify-center items-center"
            sx={{ bgcolor: "primary.main" }}
          >
            <FiUser className="text-white text-xl" />
          </Box>
          <Box className="flex flex-col text-left">
            <Typography sx={{ fontWeight: "bold", fontSize: 14 }}>
              {currentUser.name || "Name is not available"}
            </Typography>
            <Typography sx={{ fontSize: 12, width: "100%" }}>
              {currentUser.email || "Email is not available"}
            </Typography>
          </Box>
        </button>
      </Box>
    </Box>
  );
});

export default Sidebar;
